/**
 * Model reprezentujący żądanie rezygnacji (usunięcia konta) zgłoszone przez użytkownika aplikacji mobilnej.
 * Wykorzystywany do procesowania offboardingu, analizy retencji oraz zapewnienia zgodności z politykami prywatności.
 */
export class UserResignation {

  /** Globalnie unikalny identyfikator żądania rezygnacji. */
  public uuid: string;

  /** Identyfikator użytkownika (autora), który złożył wniosek o zamknięcie swojego profilu. */
  public authorUUID: string;

  /** Data i czas zarejestrowania wniosku w systemie. */
  public created: string;

  /** Zaplanowana data fizycznego usunięcia i anonimizacji danych (Timestamp).
   * Wspiera mechanizm opóźnionego usuwania (Grace Period) – konto jest blokowane,
   * ale twarde usunięcie z bazy następuje np. po 4 dniach.
   */
  public scheduled: string;

  /** Powód rezygnacji użytkownika.
   * Niezbędny do analizy wskaźnika odejść (Churn Rate) i wyciągania wniosków produktowych.
   */
  public reason: string;

}
